import './App.css';
import Navbar from './pages/navbar'
import HomePage from './pages/homepage'

function App() {
  return (
    <div>
      <Navbar/>
      <HomePage/>
    </div>
  );
}

export default App;
